import axios from "../http_v2";
export default {
  list: data => {
    return axios.get("cmsservice/cms_poster/page", data);
  },
  add: data => {
    return axios.post("cmsservice/cms_poster/add", data);
  },
  update: data => {
    return axios.post("cmsservice/cms_poster/update", data);
  },
  del(params) {
    return axios.post("cmsservice/cms_poster/delete", params);
  },
  xfs: {
    sid: data => {
      return axios.get("content-service/xinfushe/sid", data);
    },
    sso: data => {
      return axios.post("content-service/xinfushe/sso", data);
    }
  },
  template: {
    list: data => {
      return axios.get("cmsservice/cms_postertemplate/page", data);
    },
    add: data => {
      return axios.post("cmsservice/cms_postertemplate/add", data);
    },
    update: data => {
      return axios.post("cmsservice/cms_postertemplate/update", data);
    },
    del: data => {
      return axios.post("cmsservice/cms_postertemplate/delete", data);
    }
  },
  statistice: {
    list: data => {
      return axios.post("marketcenter/share/sharecode/list", data);
    },
    details: data => {
      return axios.post("marketcenter/share/code/detail/list", data);
    },
    num: data => {
      return axios.post("marketcenter/share/sharecode/stat/indicators", data);
    }
  },
  type: {
    tree(params) {
      return axios.get("cmsservice/posterSort/tree", params);
    },
    add(params) {
      return axios.post("cmsservice/posterSort/add", params);
    },
    update(params) {
      return axios.put("cmsservice/posterSort/update", params);
    },
    del(id) {
      return axios.delete("cmsservice/posterSort/del/" + id, {});
    }
  }
};
